import changeClass from '../../js/lib/changeClass';
import request from '../../js/lib/request';


var wistiaThumbnails = document.querySelectorAll('[data-private="True"]')

for (var i = 0; i < wistiaThumbnails.length; i++) {
    var url = "https://fast.wistia.com/embed/medias/" + wistiaThumbnails.item(i).dataset.wistiaid + ".json";

    request().get(url).then(function(response) {
        var img = document.getElementById("videoImg_" + response.media.hashedId);
        updateImage(response.media.assets, img);
    });
}

function updateImage(arr, imgElement) {
    var i;
    for (i = 0; i < arr.length; i++) {
        if (arr[i].type == "still_image")
        {
            imgElement.src = arr[i].url;
        }
    }
}




//const videos = document.querySelectorAll('.youtube');
//
//if (videos.length !== 0) {
//	const nb_videos = videos.length;
//	for (let i = 0; i < nb_videos; i++) {
//		// Based on the YouTube ID, we can easily find the thumbnail image
//		videos[i].parentElement.addEventListener('click', function() { playVideo(event) }, true);
//		// Reg Image??
//		videos[i].src = `//i.ytimg.com/vi/${videos[i].id}/maxresdefault.jpg`;
//		// Or Background
//		// videos[i].style.backgroundImage = `url(//i.ytimg.com/vi/${videos[i].id}/maxresdefault.jpg)`;
//	}
//	const playVideo = (event) => {
//		// get currentTarget's IMG tag
//		const imgElement = event.currentTarget.querySelector('img');
//		event.currentTarget.setAttribute('loaded', true);
//
//		// Create an iFrame with autoplay set to true
//		const iframe = document.createElement('iframe');
//		if (imgElement) {
//			// Get URL
//			const iframe_url = imgElement.getAttribute('data-url').toString();
//			// These are params I need
//			const iframe_params = 'autoplay=true&vq=hq&rel=0';
//			// Check if there is a ?query in the URL
//			if (!iframe_url.match(/([?])\w+/)) {
//				const full_url = `${iframe_url}?${iframe_params}`;
//				iframe.setAttribute('src', full_url);
//			} else {
//				const full_url = `${iframe_url}&${iframe_params}`;
//				iframe.setAttribute('src', full_url);
//			}
//			// The height and width of the iFrame should be the same as parent
//			iframe.style.width = imgElement.style.width;
//			iframe.style.height = imgElement.style.height;
//
//			// Replace the YouTube thumbnail with YouTube Player
//			imgElement.parentNode.replaceChild(iframe, imgElement);
//		}
//
//	}
//}



// WEBPACK FOOTER //
// ../components/video/video.js